import {
  styled,
  Box,
  IconButton,
  Typography,
  Popover,
  Chip,
} from "@mui/material";
import { brighthiveTheme } from "../../theme/theme";

export const CustomPopover = styled(Popover)`
  .tags-holder {
    padding: 10px;
    gap: 10px;
    display: flex;
    flex-wrap: wrap;
    max-width: 200px;
    h2 {
      font-size: 14px;
      width: 100%;
      font-size: 16px;
      font-weight: 500;
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);
      padding: 0 0 05px;
    }
  }
`;
export const CustomChip = styled(Chip)`
  background-color: ${brighthiveTheme.palette.primary.active} !important;
  font-size: 12px;
  padding: 5px 10px;
`;
